import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import PropertyViewer from '@/views/PropertyViewer.vue'
import NotFound from '@/views/NotFound.vue'
import Unsubscribe from '@/views/Unsubscribe.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'PropertyViewer',
    component: PropertyViewer
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe
  },
  { path: '*', component: NotFound, name: 'NotFound' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.query?.leadListId && to.name !== 'NotFound') next({ name: 'NotFound' })
  else next()
})

export default router
